import { render } from "./DelayEditor.vue?vue&type=template&id=8e13e58e"
import script from "./DelayEditor.vue?vue&type=script&lang=ts"
export * from "./DelayEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script